import { Header, SpaceBetween } from '@amzn/awsui-components-console';
import React from 'react';
import { useAddPipelineToRecentPage } from '../../commons';
import { useInstancesByPipeline, useGroupName } from 'src/data/redux';
import { dateRangeToStartAndEndDatetimes } from '../instance/InstanceDateRangePicker';
import { fetchInstancesByPipeline } from 'src/data/api/fetchFromAPI';
import MonitorInstanceTable from '../instance/MonitorInstanceTable';

/**
 * @returns A component that displays pipeline instances using MonitorInstanceTable
 */
export default function MonitorPipeline(props: { pipelineName: string }) {
	// Subscribe to store
	const { data, fetching } = useInstancesByPipeline(props.pipelineName);
	const instances = data || [];
	const groupName = useGroupName();

	useAddPipelineToRecentPage(props.pipelineName, groupName);

	const handleRefresh = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const dateRange = JSON.parse(searchParams.get('dateRange') || '{}');
		// TODO implement support for filter by instanceStatusId, this needs update on HammerstoneAPI
		const instanceStatusId = parseInt(searchParams.get('instanceStatusId')) || -1;
		const [startScheduleDateTime, endScheduleDateTime] = dateRangeToStartAndEndDatetimes(dateRange);

		fetchInstancesByPipeline(
			{
				pipelineName: props.pipelineName,
				groupName,
				startScheduleDateTime,
				endScheduleDateTime,
			},
			true
		);
	};

	return (
		<SpaceBetween size="l">
			<Header variant="h2">Monitor Pipeline</Header>
			<MonitorInstanceTable
				instances={instances}
				loading={fetching}
				showActivityInfo={true}
				pipelineName={props.pipelineName}
				onRefresh={handleRefresh}
			/>
		</SpaceBetween>
	);
}
